import React from 'react';

import {VisibilityContext} from 'react-horizontal-scrolling-menu';
import RightArrowIcon from './assets/RightArrow.svg';
import LeftArrowIcon from './assets/LeftArrow.svg';
import {Image} from 'antd';
function Arrow({
  children,
  disabled,
  onClick,
}: {
  children: React.ReactNode;
  disabled: boolean;
  onClick: VoidFunction;
}) {
  return (
    <div
      onClick={onClick}
      style={{
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        right: '1%',
        opacity: disabled ? '0' : '1',
        userSelect: 'none',
      }}>
      {children}
    </div>
  );
}

export function LeftArrow() {
  const {isFirstItemVisible, scrollPrev, visibleElements, initComplete} =
    React.useContext(VisibilityContext);

  const [disabled, setDisabled] = React.useState(
    !initComplete || (initComplete && isFirstItemVisible),
  );
  React.useEffect(() => {
    // NOTE: detect if whole component visible
    if (visibleElements.length) {
      setDisabled(isFirstItemVisible);
    }
  }, [isFirstItemVisible, visibleElements]);

  return (
    <Arrow disabled={disabled} onClick={() => scrollPrev()}>
      <Image
        wrapperStyle={{
          position: 'absolute',
          left: 10,
          top: '50%',
          zIndex: 10,
        }}
        width={50}
        src={LeftArrowIcon}
        preview={false}
      />
    </Arrow>
  );
}

export function RightArrow() {
  const {isLastItemVisible, scrollNext, visibleElements} =
    React.useContext(VisibilityContext);

  const [disabled, setDisabled] = React.useState(
    !visibleElements.length && isLastItemVisible,
  );
  React.useEffect(() => {
    if (visibleElements.length) {
      setDisabled(isLastItemVisible);
    }
  }, [isLastItemVisible, visibleElements]);

  return (
    <Arrow disabled={disabled} onClick={() => scrollNext()}>
      <Image
        wrapperStyle={{
          position: 'absolute',
          right: 10,
          top: '50%',
          zIndex: 10,
        }}
        width={50}
        src={RightArrowIcon}
        preview={false}
      />
    </Arrow>
  );
}
